import { useGetMenuMaster } from '~/api/menu';

import { WhatsNewModal } from './whats-new/components/WhatsNewModal';
import { WhatsNewNavEntry } from './whats-new/components/WhatsNewNavEntry';
import { useWhatsNew } from './whats-new/useWhatsNew';

const WhatsNew = () => {
  const { menuMaster } = useGetMenuMaster();
  const { entries, unreadCount, isOpen, open, close } = useWhatsNew();

  if (entries.length === 0) return null;

  return (
    <>
      <WhatsNewNavEntry
        unreadCount={unreadCount}
        drawerOpen={menuMaster.isDashboardDrawerOpened}
        onOpen={open}
      />
      <WhatsNewModal isOpen={isOpen} entries={entries} onClose={close} />
    </>
  );
};

export default WhatsNew;
